import { render } from "./LoyaltyHero.vue?vue&type=template&id=3f12d4f2&scoped=true"
import script from "./LoyaltyHero.vue?vue&type=script&lang=js"
export * from "./LoyaltyHero.vue?vue&type=script&lang=js"

import "./LoyaltyHero.vue?vue&type=style&index=0&id=3f12d4f2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f12d4f2"]])

export default __exports__